import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../config/api';
import { authStorage } from '../utils/auth';
import { useConfig } from '../context/ConfigContext';
import { getAssetUrl } from '../config/assets';
import { PageTitle } from '../components';

function EncuestaPage() {
  const navigate = useNavigate();
  const { config } = useConfig();
  const mujerKvUrl = config?.mujerKvUrl || getAssetUrl('mujerKv');
  const logoMedicina = config?.welcomeLogos?.[0]?.url || getAssetUrl('logoMedicina');
  const logoHeel = config?.welcomeLogos?.[1]?.url || getAssetUrl('logoHeel');
  const [event, setEvent] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!authStorage.getToken()) navigate('/login', { replace: true });
    api.get(endpoints.eventActive()).then(setEvent).catch(() => {});
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!feedback?.trim()) {
      setError('Escribe tu opinión o comentario');
      return;
    }
    setLoading(true);
    try {
      const token = authStorage.getToken();
      const res = await api.post(endpoints.surveys(), { eventId: event?.id, feedback: feedback.trim() }, token);
      if (res.id !== undefined || res.message === undefined) {
        setSent(true);
        setFeedback('');
      } else {
        setError(res?.message || 'Error al enviar');
      }
    } catch (err) {
      setError(err?.message || 'Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  const token = authStorage.getToken();
  if (!token) return null;

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden pb-20">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: config?.bodyBackgroundImage
            ? `linear-gradient(180deg, rgba(15, 60, 50, 0.85) 0%, rgba(20, 80, 70, 0.75) 50%, rgba(25, 100, 90, 0.7) 100%), url(${config.bodyBackgroundImage}) center/cover`
            : 'linear-gradient(180deg, #0f3c32 0%, #145046 50%, #19645a 100%)',
        }}
      />

      <div className="relative z-0 flex flex-col flex-1 items-center justify-between px-4 pt-6">
        <div className="relative z-0 flex flex-col flex-col items-center justify-between px-4 pt-10">
          <div className="relative w-full overflow-hidden rounded-lg p-3 sm:p-4 flex items-center min-h-[180px] sm:min-h-[250px]">
            {config?.headerImage && (
              <div className="z-10 flex-1 min-w-0 pl-2 sm:pl-4 mr-12 sm:mr-20">
                <img src={config.headerImage} alt="37 Simposio" className="h-auto w-full max-w-[280px] sm:max-w-[326px] object-contain object-left" />
              </div>
            )}
            {mujerKvUrl && (
              <div className="absolute right-0 bottom-0 h-full w-1/3 sm:w-1/4 flex justify-center items-end pointer-events-none">
                <img src={mujerKvUrl} alt="" className="h-[100%] sm:h-[110%] w-auto object-contain object-bottom mix-blend-screen brightness-110 opacity-50 sm:opacity-60" />
              </div>
            )}
          </div>
        </div>

        <PageTitle>Encuesta</PageTitle>

        <div className="flex-1 w-full max-w-md mx-auto p-4 overflow-y-auto">
          <div className="p-4">
            {sent ? (
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                <p className="text-green-800 font-medium">¡Gracias por tu feedback!</p>
                <p className="text-green-700 text-sm mt-2">Tu opinión nos ayuda a mejorar.</p>
                <button
                  onClick={() => setSent(false)}
                  className="mt-4 text-blue-600 font-medium text-sm"
                >
                  Enviar otro comentario
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tu opinión o comentario</label>
                  <textarea
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="¿Qué te pareció el evento? ¿Alguna sugerencia?"
                    rows={5}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    disabled={loading}
                  />
                </div>
                {error && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                    <p className="text-red-700 text-sm">{error}</p>
                  </div>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-4 px-6 rounded-xl font-semibold text-center text-gray-800 bg-[#a3e635] hover:bg-[#bef264] transition-colors shadow-lg disabled:opacity-50"
                >
                  {loading ? 'Enviando...' : 'Enviar'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      <div className="relative z-20 flex justify-between items-end px-4 py-6 pb-8 gap-4">
        <div className="flex flex-col items-start gap-2 min-w-0 flex-1">
          {logoMedicina && (
            <img src={logoMedicina} alt="Medicina Biorreguladora de Sistemas" className="h-[110%] w-auto sm:h-20 object-contain object-left max-w-[75%]" />
          )}
        </div>
        <div className="flex items-end flex-shrink-0">
          {logoHeel && (
            <img src={logoHeel} alt="Heel" className="h-8 sm:h-10 object-contain" />
          )}
        </div>
      </div>
    </div>
  );
}

export default EncuestaPage;
